
import { computed, defineComponent } from 'vue';
import { useRoute } from 'vue-router';

import NotificationDialog from 'SharedDir/components/Notification/NotificationDialog.vue';

import LoginDialog from 'components/Auth/LoginDialog.vue';
import ProfileDialog from 'components/Auth/ProfileDialog.vue';
import WafDialogWrapper from 'components/base/WafDialogWrapper.vue';
import CookiesAcceptModal from 'layouts/CookiesAcceptModal.vue';
import TheContainer from 'layouts/parts/TheContainer.vue';
import TheFooter from 'layouts/parts/TheFooter.vue';
import TheHeader from 'layouts/parts/TheHeader.vue';

export default defineComponent({
  name: 'MainLayout',
  components: {
    CookiesAcceptModal,
    WafDialogWrapper,
    ProfileDialog,
    LoginDialog,
    TheFooter,
    TheContainer,
    TheHeader,
    NotificationDialog,
  },
  setup() {
    const route = useRoute();

    const hideFooter = computed(
      () => route.meta.hideFooter === true
    );

    return {
      hideFooter,
    };
  },
});
